var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"search":_vm.search},scopedSlots:_vm._u([{key:"item.duration",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(((item.duration) + " days/" + (Number(item.duration) - 1) + " Nights")))]}},{key:"item.description",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item && item.description && item.description.length > 50
      ? ((item.description.slice(0, 50)) + "...")
      : item.description))]}},{key:"item.marketPlace",fn:function(ref){
      var item = ref.item;
return [_c('v-simple-checkbox',{attrs:{"disabled":""},model:{value:(item.marketPlace),callback:function ($$v) {_vm.$set(item, "marketPlace", $$v)},expression:"item.marketPlace"}})]}},{key:"item.actions",fn:function(ref){
      var item = ref.item;
return [_c('template-list-actions',{attrs:{"item":item},on:{"deleteItem":_vm.deleteItem,"editItem":_vm.editItem,"editItemContents":_vm.editItemContents,"showTemplateSettings":_vm.onShowTemplateSettings,"cloneItem":_vm.cloneItem}})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a00c176","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/templates/TemplatesTable.vue
// module id = null
// module chunks = 